<h2 mat-dialog-title class="mat-h2">
  Temperatures
  <button mat-icon-button class="close-button" type="button" aria-label="Close" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content>
  @if (data.readings.length) {
    <div class="temperatures-table-container">
      <table mat-table [dataSource]="dataSource" class="temperatures-table">
        <ng-container matColumnDef="time">
          <th mat-header-cell *matHeaderCellDef class="numeric-cell">Time (s)</th>
          <td mat-cell *matCellDef="let reading" class="numeric-cell">{{ reading.time }}</td>
        </ng-container>
        @for (sensorKey of sensorKeys; track sensorKey) {
          <ng-container [matColumnDef]="sensorColumnId(sensorKey)">
            <th mat-header-cell *matHeaderCellDef class="numeric-cell">Sensor {{ sensorKey }} (°C)</th>
            <td mat-cell *matCellDef="let reading" class="numeric-cell">
              {{ formatTemperature($safeNavigationMigration(reading.temperatures?.[sensorKey])) }}
            </td>
          </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <mat-paginator
      [pageSizeOptions]="pageSizeOptions"
      [pageSize]="pageSizeOptions[1]"
      showFirstLastButtons
      aria-label="Select page of temperature readings">
    </mat-paginator>
  } @else {
    <p>No temperature readings in this file.</p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button type="button" (click)="close()">Close</button>
</mat-dialog-actions>
